// import React from "react";
// import { useSelector } from "react-redux";
// import { routePaths } from "services/routing";
// import { Header, BackAction, BottomNavigation, NavIcon } from "shared";
// import ProfileSwitcher from "profiles/page/ProfileSwitcher.jsx";
// import "./MedicationSummary.scss";
// import MedicationIcon from 'shared/fullColorIcons/svgs/medication.svg';

// export default function MedicationSummary() {

//     const { data } = useSelector((state) => state.aiHealthSummary);

//     const aiSummary = React.useMemo(() => {
//         try {
//             if (!data) return null;
//             return typeof data === "string" ? JSON.parse(data) : data;
//         } catch {
//             return null;
//         }
//     }, [data]);

//     const ehrSummary = aiSummary?.ehrSummary?.[0];

//     let medications = [];

//     try {
//         const sectionData = ehrSummary?.sectionWiseSummary
//             ? JSON.parse(ehrSummary.sectionWiseSummary)
//             : null;

//         medications = sectionData?.medications || [];
//     } catch {
//         medications = [];
//     }

//     const leftElement = <ProfileSwitcher readonly={false} />;
//     const backAction = <BackAction to={routePaths.root} />;
//     const centerElement = <p className="medication-title">Medications</p>;

//     return (
//         <div className="medication-page">

//             <Header
//                 farLeftElement={backAction}
//                 leftElement={leftElement}
//                 centerElement={centerElement}
//             />

//             <div className="medication-wrapper">
//                 <div className="medication-container">

//                     {medications.length === 0 && (
//                         <div className="no-medications">
//                             No medications found.
//                         </div>
//                     )}

//                     {medications.length > 0 && (
//                         <div className="medication-card">

//                             <div className="medication-card-header">
//                                 <NavIcon Icon={MedicationIcon} />
//                                 <h4>Medication Summary</h4>
//                             </div>

//                             {medications.map((med, index) => {

//                                 const parts = med.split(":");
//                                 const name = parts[0]?.trim();
//                                 const description = parts[1]?.trim() || "";

//                                 return (
//                                     <div className="medication-row" key={index}>

//                                         {/* <div className="card-icon">
//                                             <Logo />
//                                         </div> */}

//                                         <div className="medication-info">
//                                             <div className="card-title">
//                                                 {name}
//                                             </div>

//                                             <div className="card-description">
//                                                 {description}
//                                             </div>
//                                         </div>

//                                     </div>
//                                 );
//                             })}

//                         </div>
//                     )}

//                 </div>
//             </div>

//             <BottomNavigation />

//         </div>
//     );
// }

import React from "react";
import { useSelector } from "react-redux";
import { routePaths } from "services/routing";
import ProfilePage from "profiles/page/ProfilePage";
import { BackAction, NavIcon } from "shared";
import MedicationIcon from "shared/fullColorIcons/svgs/medication.svg";
import "./MedicationSummary.scss";

export default function MedicationSummary() {

    const { data } = useSelector((state) => state.aiHealthSummary);

    const aiSummary = React.useMemo(() => {
        try {
            if (!data) return null;
            return typeof data === "string" ? JSON.parse(data) : data;
        } catch {
            return null;
        }
    }, [data]);

    const ehrSummary = aiSummary?.ehrSummary?.[0];

    let medications = [];

    try {
        const sectionData = ehrSummary?.sectionWiseSummary
            ? JSON.parse(ehrSummary.sectionWiseSummary)
            : null;

        medications = sectionData?.medications || [];
    } catch {
        medications = [];
    }

    return (
        <ProfilePage
            id="medication-page"
            centerElement="Medications"
            backAction={<BackAction to={routePaths.root} />}
        >
            <div className="medication-page">

                <div className="medication-wrapper">
                    <div className="medication-container">

                        {medications.length === 0 && (
                            <div className="no-medications">
                                No medications found.
                            </div>
                        )}

                        {medications.length > 0 && (
                            <div className="medication-card">

                                <div className="medication-card-header">
                                    <NavIcon Icon={MedicationIcon} />
                                    <h4>Medication Summary</h4>
                                </div>

                                {medications.map((med, index) => {

                                    const parts = med.split(":");
                                    const name = parts[0]?.trim();
                                    const description = parts[1]?.trim() || "";

                                    return (
                                        <div className="medication-row" key={index}>

                                            <div className="medication-info">
                                                <div className="card-title">
                                                    {name}
                                                </div>

                                                <div className="card-description">
                                                    {description}
                                                </div>
                                            </div>

                                        </div>
                                    );
                                })}

                            </div>
                        )}

                    </div>
                </div>

            </div>
        </ProfilePage>
    );
}
